import { Component, ElementRef, inject, OnInit, output, OutputEmitterRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-splash-screen',
  templateUrl: './splash-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {
  public readonly elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);
  public readonly animationDone: OutputEmitterRef<void> = output();

  public ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('animationend', event => {
      /* istanbul ignore else */
      if (event.target === this.elementRef.nativeElement) {
        this.animationDone.emit();
      }
    });
  }
}
